import { Component, Inject, OnInit } from '@angular/core';
import { Observable, Subscription, timer } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ClientService } from 'tekkeys-common';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-resend-confirmation-mail',
  templateUrl: './resend-confirmation-mail.component.html',
  styleUrls: ['./resend-confirmation-mail.component.scss'],
})
export class ResendConfirmationMailComponent implements OnInit {
  isCount = true;
  timer: any;
  time = 59;
  timer$: Observable<number>;
  timerSub: Subscription;
  show = false;

  constructor(
    public dialogRef: MatDialogRef<ResendConfirmationMailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clientService: ClientService
  ) {}

  ngOnInit(): void {
    this.countDown(0);
    this.dialogRef.backdropClick().subscribe(() => {
      this.closeDialog();
    });
  }
  closeDialog() {
    this.dialogRef.close();
  }

  countDown(time: number) {
    this.timer$ = timer(0, 1000).pipe(
      map((i) => {
        const remainingTime = time - i;
        return remainingTime;
      }),
      take(time + 1)
    );
    this.timerSub = this.timer$.subscribe();
  }

  confirmationMail() {
    const payload = this.data.email;
    this.clientService.resendConfirmationMail(payload).subscribe();
  }
}
